export const DRAWER_TYPES = {
  CallList: 'CallList',
  ConvertSendoverToSendout: 'ConvertSendoverToSendout',
  CreateCall: 'CreateCall',
  CreatePlacement: 'CreatePlacement',
  CreateSendoutInterview: 'CreateSendoutInterview',
  CreateSendout: 'CreateSendout',
  CreateSendover: 'CreateSendover',
  Duplicates: 'Duplicates',
  SendoutDetails: 'SendoutDetails',
  SendoutDetailsEdit: 'SendoutDetailsEdit',
  SendoutInterviewDetails: 'SendoutInterviewDetails',
  SendoverDetails: 'SendoverDetails',
  SendoverDetailsEdit: 'SendoverDetailsEdit'
};
